export default {
	seconds: 'second(s)',
	minutes: 'minute(s)',
	hours: 'hour(s)',
	days: 'day(s)',
	months: 'month(s)',
	years: 'year(s)',
};
